import $ from 'jquery';
import 'bootstrap';
import 'animate.css';
import AOS from 'aos';

const general = {
    toggleHover: function() {
        if (window.innerWidth > 992) {
            document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
                everyitem.addEventListener('mouseover', function(e) {
                    let el_link = this.querySelector('a[data-bs-toggle]');
                    if (el_link != null) {
                        let nextEl = el_link.nextElementSibling;
                        el_link.classList.add('show');
                        nextEl.classList.add('show');
                    }
                });

                everyitem.addEventListener('mouseleave', function(e) {
                    let el_link = this.querySelector('a[data-bs-toggle]');
                    if (el_link != null) {
                        let nextEl = el_link.nextElementSibling;
                        el_link.classList.remove('show');
                        nextEl.classList.remove('show');
                    }
                });
            });

            $('.navbar .nav-link.dropdown-toggle').click(function(e) {
                if (this.href) {
                    location.href = this.href;
                }
            });
        } else {
            $('.navbar .nav-link.dropdown-toggle').click(function(e) {
                if ($(this).attr('aria-expanded') == 'true') {
                    location.href = this.href;
                } else {
                    $(this).next('.dropdown-menu').toggle();
                    $(this).next('.dropdown-menu').toggleClass('visible')
                }

                const val = $(this).attr('aria-expanded');

                if (val == true) {
                    $(this).attr('aria-expanded', 'false');
                } else {
                    $(this).attr('aria-expanded', 'true');
                }
            });
        }
    },

    contactButtonBehaviour: function() {
        $(document).scroll(function() {
            let $btn = $('.js-contact-btn');
            let $footer = $('#footer');

            if ($btn.offset().top + $btn.height() >= $footer.offset().top - 10) {
                $btn.css('position', 'absolute');
            }

            if ($(document).scrollTop() + window.innerHeight < $footer.offset().top) {
                $btn.css('position', 'fixed');
            }
        })
    },
}
export default general;

(function($) {
    $(document).ready(function() {
        AOS.init();
        general.toggleHover();
        general.contactButtonBehaviour();
        const appHeight = () => {
            const doc = document.documentElement
            doc.style.setProperty('--app-height', `${window.innerHeight}px`)
        }
        window.addEventListener('resize', appHeight)
        appHeight()

    });
})($);